import React from "react";
import { Navigate, useParams, useLocation } from "react-router-dom";

// Legacy route — singles and doubles are now displayed on a single
// /player/:id page with a discipline tab. Redirect anything still pointing
// at /team-player/:id to the unified detail page with the debel tab open.
const TeamPlayerDetails: React.FC = () => {
  const { playerId } = useParams<{ playerId: string }>();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  params.set("tab", "debel");

  return <Navigate to={`/player/${playerId ?? ""}?${params.toString()}`} replace />;
};

export default TeamPlayerDetails;
